import { apiSlice } from "../../app/apiSlice";
import { Grupo } from "../../types/grupo/Grupo";

import configUrls from "../../config/configUrls";
const endpointUrl = configUrls.GRUPO_ACOMPANHAMENTO_API_EP;





function createGrupo(obj: Grupo) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateGrupo(obj: Grupo) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteGrupo({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}

function getGrupos(search: string) {
    return {
        url: `${endpointUrl}/filter?search=${search}`,
        method: "GET",
    }
}




export const grupoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getGrupo: query<Grupo, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["Grupo"],
        }),
        getGrupos: query<Grupo[], string>({
            query: getGrupos,
            providesTags: ["Orgao"],
        }),


        createGrupo1: mutation<Grupo, Grupo>(
            {
                query: createGrupo,
                invalidatesTags: ["Grupo"]
            }),


        createGrupo: mutation<Grupo, Grupo>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o grupo
                    body: obj,         // Corpo da requisição com os dados do novo grupo
                }),
                invalidatesTags: ["Grupo"]
            }),

        updateGrupo: mutation<Grupo, Grupo>({
            query: updateGrupo,
            invalidatesTags: ["Grupo"]
        }),

        deleteGrupo: mutation<Grupo, { id: string }>(
            {
                query: deleteGrupo,
                invalidatesTags: ["Grupo"],
            }),


    }),

});
export const {
    useGetGrupoQuery,
    useCreateGrupoMutation,
    useUpdateGrupoMutation,
    useDeleteGrupoMutation,
    useCreateGrupo1Mutation,
    useGetGruposQuery,
} = grupoApiSlice